import React, { useState, useRef, useEffect } from "react";

const ActionsMenu = ({ items }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      {/* Trigger */}
      <button
        onClick={() => setOpen(!open)}
        className="px-2 py-1 border border-border rounded-md text-xs"
      >
        Actions ▾
      </button>

      {/* Desktop Dropdown */}
      {open && (
        <div className="hidden md:block absolute right-0 mt-2 w-48 bg-dry border border-border rounded-lg shadow-lg z-50 ">
          <ul className="text-sm text-text">
            {items.map((item, idx) => (
              <li
                key={idx}
                onClick={item.onClick}
                className={`px-4 py-2 hover:bg-redlight cursor-pointer ${
                  item.danger ? "text-red-600 font-medium" : ""
                }`}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Mobile Bottom Sheet */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-end md:hidden">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-40"
            onClick={() => setOpen(false)}
          />
          {/* Bottom Sheet */}
          <div className="relative w-full bg-dry  rounded-t-lg shadow-lg p-4 max-h-[70%] overflow-y-auto animate-slide-up">
            <div className="flex justify-end">
              <button
                onClick={() => setOpen(false)}
                className="text-textGray text-lg font-bold"
              >
                ✕
              </button>
            </div>
            <ul className="text-sm text-text">
              {items.map((item, idx) => (
                <li
                  key={idx}
                  onClick={item.onClick}
                  className={`px-4 py-3 hover:bg-gray-100 cursor-pointer ${
                    item.danger ? "text-red-600 font-medium" : ""
                  }`}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionsMenu;
